/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from "react";
import Navbar from "../components/TopNav";
// import prostarter from '../images/landing/prostarter.svg';
// import sed from '../images/landing/sed.svg';
// import redkite from '../images/landing/redkite.svg';
import { withRouter } from "react-router-dom";
// import GameMechanics from "../components/landing/gameMechanics";
// import MarketSeller from "../components/landing/marketSeller";
// import MonsterLab from "../components/landing/MonsterLab";
// import Partners from "../components/landing/Partners";
import Footer from "../components/Footer";
// import Contact from "../components/landing/Contact";
// import Features from '../components/landing/feature';
// import Team from "../components/landing/Team";
import VideoModal from "../components/landing/videoModal";
import GameVideoModal from "../components/landing/GameVideoModal";
// import Slider from "../components/landing/Slider";
// import ProjectRoadMap from "../components/landing/ProjectRoadMap";
import Video from "../components/landing/video";
const LandingPage = ({ history }) => {
  const [toggle, setToggle] = useState(false);
  const [toggle2, setToggle2] = useState(false);
  // const [isOverLay, setOverLay] = useState(true);
  return (
    <div className="row no-gutters landing">
      <Navbar />
      <VideoModal toggle={toggle} onCloseModal={() => setToggle(false)} />
      <GameVideoModal toggle={toggle2} onCloseModal={() => setToggle2(false)} />
      <Video />
      {/* <Slider
        setToggle={(value) => setToggle(value)}
        setToggle2={(value) => setToggle2(value)}
      /> */}
      {/* {isOverLay &&<div className="overlay">
        <button onClick={()=> setOverLay(false)} className="btn"><img width="80%" src={cross} alt="" /></button>
        <h5>LAUNCHPADS</h5>
        <p>$MONS Token IDO will be held on three launchpads. $MONS will be listed on Pancakeswap on the 15th of September 2021.</p>
        <div>
          <a target="_blank" rel="noreferrer" href="https://seedify.fund/"><img src={sed} alt="" /></a>
          <span></span>
          <a target="_blank" rel="noreferrer" href="https://prostarter.io/"><img src={prostarter} alt="" /></a>
          <span></span>
          <a target="_blank" rel="noreferrer" href="https://redkite.polkafoundry.com/#/dashboard"><img src={redkite} alt="" /></a>
        </div>
      </div>} */}
      {/* <Features /> */}
      {/* <GameMechanics/>
      <Partners/>
      <MarketSeller/>
      <MonsterLab/>
      <Team/>
      <Contact /> */}
      <Footer />
    </div>
  );
};

export default withRouter(LandingPage);
